/**
 * @file Form Newsletter
 */

/**
 * Form Newsletter component
 */
const vFormNewsletter = () => {
	const formNewsletter = document.querySelector( '.v-form-newsletter' );

	if ( ! formNewsletter ) {
		return;
	}

	const dataLayer = window.dataLayer || [];

	/**
	 * Push data to Google Analytics on form submission
	 */
	const formSubmissionCallback = () => {
		if ( ! formNewsletter.classList.contains( 'v-form-newsletter--consumer' ) && ! formNewsletter.classList.contains( 'v-form-newsletter--agent' ) ) {
			return;
		}

		const isConsumer = formNewsletter.classList.contains( 'v-form-newsletter--consumer' );

		dataLayer.push( {
			event:          'Segment Form Submission',
			vEventCategory: isConsumer ? 'Consumer' : 'Agent',
			vEventAction:   'Submit',
			vEventLabel:    'Newsletter',
		} );
	};

	/**
	 * Wrap Hubspot submit so it can be styled
	 */
	/* const wrapSubmit = () => {
		const hsSubmit  = formNewsletter.querySelector( '.hs-button[type="submit"]' );
		const newSubmit = formNewsletter.querySelector( '.v-arrow-link' );
		if ( ! hsSubmit || newSubmit ) {
			return;
		}
		const submitParent = hsSubmit.parentNode;

		const button           = document.createElement( 'button' );
		const arrow            = document.createElement( 'span' );
		button.classList.add( 'v-arrow-link', 'v-arrow-link--small', 'v-arrow-link--to-button', 'v-form-newsletter__submit' );
		button.setAttribute( 'type', 'submit' );
		button.innerText       = hsSubmit.value;
		arrow.classList.add( 'v-arrow' );
		submitParent.insertBefore( button, hsSubmit );
		button.appendChild( arrow );
		hsSubmit.style.display = 'none';
	};
	wrapSubmit();

	const config   = {
		childList: true,
		subtree:   true,
	};
	const observer = new MutationObserver( wrapSubmit );
	observer.observe( formNewsletter, config ); */

	// formNewsletter.ownerDocument.addEventListener( 'hsvalidatedsubmit', formSubmissionCallback );
	formNewsletter.querySelector( '.wpcf7' ).addEventListener( 'wpcf7mailsent', formSubmissionCallback );
};

export default vFormNewsletter;
